@if (isMatListItem() === false) {
  <mat-form-field [appearance]="appearance()" [floatLabel]="floatLabel" class="flex-1">
    <mat-label>{{label()}}</mat-label>
    <div matSuffix="" class="flex items-center">
      @if (isLoadingLenders === true) {
        <mat-spinner diameter="14" class="mx2"></mat-spinner>
      }
    </div>
    <input [formControl]="control()" type="text" matInput="" [matAutocomplete]="lenderAutoComplete" [required]="required() !== false" [attr.cdkFocusInitial]="focus() !== false ? 'true' : null" autocomplete="off">
    <mat-autocomplete autoActiveFirstOption="" #lenderAutoComplete="matAutocomplete" [displayWith]="displayWithLender">
      @if (required() === false) {
        <mat-option [value]="null">
          <span translate="">None</span>
        </mat-option>
      }
      @for (lender of lendersFiltered; track lender) {
        <mat-option [value]="lender">
          {{lender.name}}
        </mat-option>
      }
    </mat-autocomplete>
  </mat-form-field>
} @else {
  <mat-list-item>
    <label>{{label()}}</label>
    <mat-form-field floatLabel="never" class="inline-field">
      <div matSuffix="" class="flex items-center">
        @if (isLoadingLenders === true) {
          <mat-spinner diameter="14" class="mx2"></mat-spinner>
        }
      </div>
      <input [formControl]="control()" type="text" matInput="" [matAutocomplete]="lenderAutoComplete" [required]="required() !== false" [attr.cdkFocusInitial]="focus() !== false ? 'true' : null" autocomplete="off">
      <mat-autocomplete class="inline-autocomplete extendable-autocomplete" #lenderAutoComplete="matAutocomplete" [displayWith]="displayWithLender">
        @if (required() === false) {
          <mat-option [value]="null">
            <span translate="">None</span>
          </mat-option>
        }
        @for (lender of lendersFiltered; track lender) {
          <mat-option [value]="lender">
            <span class="inline-autocomplete-option">{{lender.name}}</span>
          </mat-option>
        }
      </mat-autocomplete>
    </mat-form-field>
  </mat-list-item>
}
